import { Component, OnInit, HostListener, HostBinding, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, UrlSegment } from "@angular/router";
import { LoginUserService } from '../../core/services/login-user.service';
import { NotificationService } from '../../core/services/notification.service';
import { IMAGE_BASE__URL } from '../../core/services/CusHttp';
// import 'rxjs/add/operator/switchMap';
@Component({
  selector: 'app-page-top',
  templateUrl: './page-top.component.html',
  styleUrls: ['./page-top.component.scss']
})
export class PageTopComponent implements OnInit {
  isShow: boolean;
  // @ViewChild('topnav') topnav:ElementRef;
  private tabShow: number = 1;//登录和注册切换
  public isLogin: boolean = false;//true 登录  false 没有登楼 请登楼
  public userWindonShow: string = "hidden";
  public userType: string;  //用户角色
  public ImgUrl: string = IMAGE_BASE__URL;
  public userHeaderImg: string = null;//用户图像
  public noticeNum: number = 0;//消息
  public
  constructor(
    private el: ElementRef,
    private _router: Router,
    private _activeRoute: ActivatedRoute,
    private _login: LoginUserService,
    public _notiveService: NotificationService,
  ) { }

  ngOnInit() {
    this.isLogin = this._login.isLogin();  //获取登楼状态  如果没有登陆

    let tmp = this._login.getLoginInfo();
    this.userType = tmp["type"] + '';
    // console.log("获取登楼状态2", this.userType);
    switch (this.userType) {
      case '1':
        this.userHeaderImg = tmp['headimg'];
        break;
      case '3':
        this.userHeaderImg = tmp['logo'];
        break;
      case '2':
        '';
        break;
    }
    this._login.user$.subscribe(user => {
      this.userType = user['type'] + '';
      switch (this.userType) {
        case '1':
          this.userHeaderImg = user['headimg'];
          break;
        case '3':
          this.userHeaderImg = user['logo'];
          break;
        case '2':
          '';
          break;
      }
    });
    //获取消息个数
    this.getNoticeCount();
  }


  //根据登陆信息设置路由跳转
  jumpToCenter(event) {
    let queryObj = {};//路由参数
    queryObj['user'] = event;
    this._router.navigate(['/user-info/login-register'], { queryParams: queryObj });
  }
  //点击logo跳转到首页
  jumpToHome() {
    this._router.navigate(['/home']);
  }
  //退出登录状态
  signOut() {
    localStorage.clear();
    this._login.setLogin(false);
    this.isLogin = false;
    this.userHeaderImg = null;
    this._router.navigate(['/']); //company center
  }


  //用户编辑信息
  userChangeData() {
    this.userWindonShow === 'show' ? this.userWindonShow = "hidden" : this.userWindonShow = "show";
  }
  // @HostBinding('attr.role') role = 'userWindow';
  // @HostBinding('class.user-window')
  @HostListener('body:click', ['$event'])
  onClick(event: any) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.userWindonShow = "hidden"
    }
  }

  // //通知消息
  //获取消息个数
  getNoticeCount() {
    if (this.isLogin) {
      this._notiveService.getUnreadCount().then(resp => {
        this.noticeNum = parseInt(resp['data']);
      })
    }
  }
  // enterInterview(event) {
  //   switch (event) {
  //     case "notice":
  //       this.noticeShow = true;
  //       break;
  //     case 'infor':
  //       this.userWindonShow = 'show';
  //   }
  // }
  // leaveInterview(event) {
  //   switch (event) {
  //     case "notice":
  //       this.noticeShow = false;
  //       break;
  //     case 'infor':
  //       this.userWindonShow = 'hidden';
  //   }
  // }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/page-top/page-top.component.ts